export enum Direction {
  horizontal = 'H',
  vertical = 'V'
}
